import './ListSort.css';

// S12a — THE SORT CONTROL. Huan, on the Clients screen: "I don't even know
// what order it is in now."
//
// The old screen sorted by `updated_at` descending and said so only in a
// caption that appeared when the list was truncated. A sort a human cannot
// SEE reads as no sort at all, so this control does two jobs at once: it
// changes the order, and it is the place the current order is written down.
// The lit chip names the order in words — "Name A–Z", "Newest first" — and
// tapping it again flips it, which is how the same three chips reach six
// orders without a sixth chip.
//
// Chips, not a <select>: the screen already speaks in pills (S7's counted
// piles), a select hides its options behind a menu, and a pill is a bigger
// thumb target than a dropdown row on a phone.

export type SortDir = 'asc' | 'desc';

export interface SortOption {
  key: string;
  /** The dimension, stable across directions — "Name", "Client", "Newest". */
  label: string;
  /** How this dimension reads in each direction. Shown ONLY on the lit
   *  chip, so the row stays quiet and the current order is unmissable. */
  ascWord: string;
  descWord: string;
  /** Which way it points the first time it is picked. */
  defaultDir: SortDir;
}

export interface ListSortProps {
  options: readonly SortOption[];
  activeKey: string;
  dir: SortDir;
  onChange: (key: string, dir: SortDir) => void;
}

export function ListSort({ options, activeKey, dir, onChange }: ListSortProps) {
  return (
    <div class="list-sort" role="group" aria-label="Sort order">
      <span class="list-sort__lead">Sorted</span>
      {options.map((o) => {
        const on = o.key === activeKey;
        return (
          <button
            type="button"
            key={o.key}
            class={on ? 'list-sort__chip list-sort__chip--on' : 'list-sort__chip'}
            aria-pressed={on}
            onClick={() => onChange(o.key, on ? (dir === 'asc' ? 'desc' : 'asc') : o.defaultDir)}
          >
            {o.label}
            {on ? <b class="list-sort__dir">{dir === 'asc' ? o.ascWord : o.descWord}</b> : null}
          </button>
        );
      })}
    </div>
  );
}
